export default "__VITE_ASSET__B$A5JC2z__"